import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ContractWidget } from '../../../../models';
import { Contract } from '../../../../models/contract';
import { PortalCollapsibleComponent } from '../../../../customer-portal/components/portal-collapsible/portal-collapsible.component';
import { SharedModule } from '../../../../shared/shared.module';
import { PoolObject } from 'app/core/contract/poolObject.model';
import { PortalDeviceDetailsComponent } from 'app/products/electronic/components/portal-device-details/portal-device-details.component';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { ContractsService } from 'app/customer-portal';
import { isObjectDetailsComplete } from '../../utils/helper.functions';

@Component({
    selector: 'app-insured-device-widget',
    imports: [PortalCollapsibleComponent, SharedModule, PortalDeviceDetailsComponent, CtrlIconComponent],
    templateUrl: './insured-device-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuredDeviceWidgetComponent implements ContractWidget {
    public contract = input.required<Contract>();

    private contractService = inject(ContractsService);

    protected device = computed(() =>
        this.contract().objectPool.find((obj: PoolObject) => obj.ObjectType !== 'Objektiv'),
    );

    protected lens = computed(() =>
        this.contract().objectPool.find((obj: PoolObject) => obj.ObjectType === 'Objektiv'),
    );

    protected isComplete = computed(() =>
        this.contract().objectPool.every((device) => isObjectDetailsComplete(device)),
    );

    protected title = computed(() =>
        this.device().ObjectType === 'Haushaltsgerät'
            ? this.device().ObjectDescription + ' ' + this.device().ObjectModel
            : this.device().ObjectModel + ' ' + this.device().ObjectDescription,
    );

    protected icon = computed(() => {
        switch (this.device().ObjectType) {
            case 'Smartwatch':
                return 'smartwatch';
            case 'Kamera':
                return 'camera';
            case 'Notebook':
                return 'notebook';
            case 'Beamer':
                return 'beamer';
            case 'Haushaltsgerät':
                return 'appliance';
            case 'Fernseher':
                return 'tv';
            case 'PC / Monitor':
                return 'pc-monitor';
            case 'Konsole':
                return 'console';
            case 'VR-Brille':
                return 'vr-glasses';
            case 'Kopfhörer':
                return 'headphones';
            case 'Smartphone':
                return 'smartphone-2';
            case 'Tablet':
                return 'tablet';
            default:
                return 'smartphone-2';
        }
    });

    protected subtitleAlert = computed(() => {
        if (this.isComplete()) {
            return undefined;
        } else {
            return this.device().ObjectType === 'Smartphone' ? 'IMEI fehlt' : 'Seriennummer fehlt';
        }
    });

    public submit(updatedDevices: PoolObject[]): void {
        const poolObjects = this.contract().objectPool.map((item: PoolObject) => {
            const matchingItem = updatedDevices.find((updatedItem) => item.Id === updatedItem.Id);
            if (matchingItem) {
                return { ...item, ObjectDetail: matchingItem.ObjectDetail };
            } else {
                return item;
            }
        });
        this.contractService.updateInsuredObjects(this.contract().id, poolObjects).subscribe();
    }
}
